export default [
  require("/opt/buildhome/repo/node_modules/infima/dist/css/default/default.css"),
  require("/opt/buildhome/repo/node_modules/@docusaurus/theme-classic/lib/prism-include-languages"),
  require("/opt/buildhome/repo/node_modules/@docusaurus/theme-classic/lib/nprogress"),
  require("/opt/buildhome/repo/src/css/custom.scss"),
  require("/opt/buildhome/repo/src/clientModules/sentry.js"),
  require("/opt/buildhome/repo/src/clientModules/patchDomForTranslate.js"),
];
